import React, { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./addEditSubscriptionModal.module.css";
import { Input } from "@/components/Core/Input";
import { TextArea } from "@/components/Core/TextArea";
import { Button } from "@/components/Core/Button";
import { RenderToast } from "@/helper/HelperFunction";
import { FaCircleCheck, FaPlus } from "react-icons/fa6";
import { HiOutlineTrash } from "react-icons/hi2";

function AddEditSubscriptionModal({ show, setShow, data }) {
  const [name, setName] = useState(data?.name || "");
  const [price, setPrice] = useState(data?.price || "");
  const [description, setDescription] = useState(data?.description || "");
  const [features, setFeatures] = useState(data?.features || [""]);

  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header={data ? "Edit Plan" : "Add New Plan"}
      noPadding
      showCloseIcon={true}
      footerStyles={{
        justifyContent: "space-between",
        backgroundColor: "var(--white-color)",
        borderTop: "none",
      }}
      footerContainer={
        <div
          className={`${classes.footerWrapper} ${
            data && classes.addEditSubscriptionFooter
          }`}
        >
          <Button
            label={data ? "Update" : "Create"}
            onClick={() => setShow(false)}
            type="rounded"
          />
          <Button
            type="rounded"
            variant="danger-outline"
            label="Cancel"
            onClick={() => setShow(false)}
          />
        </div>
      }
    >
      <div className={classes.formContainer}>
        <Input
          label="Plan Name"
          placeholder="Enter Plan Name"
          value={name}
          setter={setName}
        />
        <Input
          label="Plan Price"
          placeholder="Enter Plan Price"
          value={price}
          setter={setPrice}
        />
        <TextArea
          label="Description"
          placeholder="Enter Description"
          value={description}
          setter={setDescription}
        />
        <div className={classes.benefitsWrapper}>
          {features?.map((benefit, index) => (
            <div className={classes.benefit}>
              <Input
                placeholder={`Enter Feature ${index + 1}`}
                value={benefit}
                setter={(e) => {
                  const newFeatures = [...features];
                  newFeatures[index] = e;
                  setFeatures(newFeatures);
                }}
                features
              />
              <HiOutlineTrash
                onClick={() => {
                  if (features?.length > 1) {
                    setFeatures(features.filter((_, i) => i !== index));
                  } else {
                    RenderToast({
                      message: "All Features cannot be deleted",
                      type: "error",
                    });
                  }
                }}
                size={20}
                stroke="red"
                cursor="pointer"
              />
            </div>
          ))}
        </div>
        <div className={classes.addMoreBtnWrapper}>
          <Button
            className={classes.addMoreBtn}
            leftIcon={<FaPlus size={20} />}
            onClick={() => {
              if (features[features?.length - 1] === "") {
                RenderToast({
                  message: "First fill all features",
                  type: "error",
                });
              } else {
                setFeatures([...features, ""]);
              }
            }}
          />
        </div>
      </div>
    </ModalSkeleton>
  );
}

export default AddEditSubscriptionModal;
